import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { Project } from '~/common/entities/Project/ProjectTypes';
import { ListView } from '~/common/components/ListView';
import { useProjectContext } from './ProjectsContext';
import { ProjectListItem } from './ProjectListItem';
import React, { useCallback, useMemo } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';

export const ProjectsList: React.FC = () => {
  const [{ data: projects = [] }] = ProjectApi.hooks.useProjectsQuery();
  const { searchTerm, orderType, filterTag } = useProjectContext();

  const alphabeticalOrdering = useCallback((p: Project) => {
    return p.name.toLowerCase();
  }, []);

  const tagOrdering = useCallback((p: Project) => {
    if (p.tags?.length === 0) {
      return 'zzzzzzzzzzzzzzz';
    }
    return p.tags;
  }, []);

  const ordering = useMemo(() => {
    if (orderType === 'alphabetical') {
      return [alphabeticalOrdering, tagOrdering];
    }
    return [tagOrdering, alphabeticalOrdering];
  }, [orderType]);

  return (
    <ListView
      search={searchTerm}
      data={projects}
      searchFields={(p) => [p.name, ...(p.tags ?? [])]}
      orderBy={ordering}
      mt={5}
      render={({ data }) => (
        <Grid
          templateColumns="repeat(3, minmax(0, 1fr))"
          columnGap={3}
          rowGap={3}
        >
          {data
            .filter((project) => !filterTag || project.tags.includes(filterTag))
            .map((project) => (
              <GridItem key={project.id}>
                <ProjectListItem project={project} />
              </GridItem>
            ))}
        </Grid>
      )}
    />
  );
};
